// extracted by mini-css-extract-plugin
export var button = "_10-0";
export var buttonContent = "_10-e";
export var buttonGroup = "_10-c";
export var dontRestrainIconWidth = "_10-a";
export var dropdownButton = "_10-b";
export var iconContainer = "_10-9";
export var lg = "_10-4";
export var md = "_10-3";
export var pending = "_10-f";
export var sm = "_10-2";
export var spinner = "_10-d";
export var squared = "_10-8";
export var wrapText = "_10-g";
export var xl = "_10-5";
export var xs = "_10-1";
export var xxl = "_10-6";
export var xxxl = "_10-7";